var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.pan}},[_vm._v(_vm._s(_vm.actualStarName)),_c('i',{staticClass:"fas fa-eye ms-1"})])}
var staticRenderFns = []

export { render, staticRenderFns }